import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { GenericResponse } from '@interfaces';
import { Observable } from 'rxjs';
import { NewContractLargeAccounts, NewOffer } from './new-contract-large-accounts.model';

@Injectable({
  providedIn: 'root'
})
export class NewContractLargeAccountsService {
  constructor(private http: HttpClient, private config: ConfigService) { }

  public getOffers(params: any): Observable<GenericResponse> {
    if (!params.Filter) {
      delete params.Filter;
    }
    return this.http.get<GenericResponse>(this.config.getUrl('maestros.getOffers'), { params });
  }

  public putQueryOffer(params): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('contrato.putQueryOffer') + params, {});
  }

  public getTraddingAccounts(params: any): Observable<GenericResponse> {
    this.deleteFilter(params);
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getAccounts'), { params });
  }

  public getSocialReason(params: any): Observable<GenericResponse> {
    this.deleteFilter(params);
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getBusinesses'), { params });
  }

  public getInstallations(params: any): Observable<GenericResponse> {
    this.deleteFilter(params);
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getInstallations'), { params });
  }

  public getCampaigns(params): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.offers.getCampaigns'), { params });
  }

  public getViasTypes(): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl('maestros.getTipoVia'));
  }

  public getPostalCode(codPostal: string): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl('maestros.getCodigoPostal', { codPostal }));
  }

  public setContract(body: NewContractLargeAccounts): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.config.getUrl('contrato.setContractGC'), body);
  }

  public setOffer(body: NewOffer): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.config.getUrl('grandesCuentas.offers.setOffer'), body);
  }

  public paperSign(params): Observable<any> {
    return this.http.get(this.config.getUrl('contrato.getContractGC'), {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
      params
    });
  }

  public digitalSign(CodigoContrato: string): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(
      this.config.getUrl('contrato.digitalSignatureGC'),
      {},
      { params: { CodigoContrato } }
    );
  }

  public deleteFilter(params: any): void {
    if (!params.Filter) {
      delete params.Filter;
    }
  }
}
